<template>
  <div
    v-show="state != 'error'"
    class="t3m-ObjectiveFinder-transmissionCurve-chartWrapper"
  >
    <div v-if="state === 'loading'" class="t3m-ObjectiveFinder-spinner">
      <b-spinner />
    </div>
    <span v-if="state === 'error'">Error</span>
    <apexchart
      v-show="state === 'complete'"
      type="line"
      :height="chartHeight"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueApexCharts from "vue-apexcharts";
import xml2js from "xml2js";
import { data } from "../shared";
import { BSpinner } from "bootstrap-vue";

export default {
  data() {
    return {
      state: "loading",
      series: [
        {
          name: "Transmission",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          toolbar: {
            export: {
              svg: {
                filename: this.objectives[0].matnr + '_' + this.objectives[0].objectiveName,
              },
              png: {
                filename: this.objectives[0].matnr + '_' + this.objectives[0].objectiveName,
              },
              csv: {
                filename: this.objectives[0].matnr + '_' + this.objectives[0].objectiveName,
              },
            }
          },
          type: "line",
          zoom: {
            enabled: false,
          },
          parentHeightOffset: 0,
          sparkline: {
            enabled: this.thumb,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          x: {
            formatter: function (value) {
              return value + " λ/nm";
            },
          },
          y: {
            formatter: function (value) {
              return Math.round(value) + " %";
            },
          },
        },
        stroke: {
          curve: "straight",
          width: 1.5,
        },
        grid: {
          row: {
            opacity: 0.5,
          },
        },

        xaxis: {
          type: "numeric",
          categories: [
            300,
            400,
            500,
            600,
            700,
            800,
            900,
            1000,
            1100,
            1200,
            1300,
          ],
          labels: {
            rotate: 0,
          },
          tickAmount: 7,
          min: 300,
          max: 1000,
          title: {
            text: "λ / nm",
          },
        },
        yaxis: {
          type: "numeric",
          labels: {
            rotate: 0,
            formatter: function (value) {
              return Math.round(value);
            },
          },
          min: 0,
          max: 100,
          tickAmount: 5,
          title: {
            text: "Transmission / %",
          },
        },
      },
    };
  },
  props: {
    objectives: Array,
    thumb: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.loadData();
  },
  components: {
    apexchart: VueApexCharts,
    BSpinner,
  },
  computed: {
    ...mapState(["selectedObjective", "objectivesToCompare"]),
    chartHeight: function () {
      return this.thumb ? 40 : 400;
    },
    transmissionCurveDataPaths: function () {
      let p = [];
      this.objectives.forEach((o) => {
        p.push(o.transmissionCurveDataPath);
      });
      return p;
    },
  },
  watch: {
    selectedObjective: function () {
      this.loadData();
    },
    objectivesToCompare: function () {
      this.loadData();
    },
  },
  methods: {
    loadData: async function () {
      this.state = "loading";
      this.series = []; // clear array

      let responses = await data.getXML(this.transmissionCurveDataPaths);

      if (!responses.length) {
        this.state = "error";
        return;
      }

      responses.forEach((response) => {
        xml2js.parseString(
          response.data,
          {
            explicitArray: false,
          },
          (err, result) => {
            if (err) {
              this.state = "error";
              return;
            } else {
              let seriesData = [];

              for (
                let index = 0;
                index < result.part.transmission.point.length;
                index += 5
              ) {
                const p = result.part.transmission.point[index];
                seriesData.push({
                  x: parseInt(p.$.w),
                  y: Math.round(p.$.t * 10000) / 100,
                });
              }

              if (seriesData[seriesData.length - 1].x > 1200) {
                this.chartOptions = {
                  xaxis: {
                    max: 1300,
                    tickAmount: 10,
                  },
                };
              }

              this.series.push({
                name: result.part.$.no.slice(-6),
                data: seriesData,
              });
            }
          }
        );
      });
      if (this.series.length) {
        this.state = "complete";
      } else {
        this.state = "error";
      }
    },
  },
};
</script>

<style>
</style>
